import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@shared/auth/constants/permissions.constant";
import { StockStatisticsRoutePaths } from "../stock-statistics-route-paths";

export const STATISTICS_SIDENAV_LINK = new InjectionToken<void>("STATISTICS_SUB_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("statistics", [
      {
        id: "stock-trends",
        label: "STATISTICS.ITEMS.STOCK_TRENDS",
        icon: "trend",
        routerLink: `${StockStatisticsRoutePaths.ROOT}${StockStatisticsRoutePaths.TREND}`,
        permissions: COMMON_GUARD_OPTIONS.STOCK_STATISTICS.VIEW.permissions,
      },
      {
        id: "stock-run-list",
        label: "STATISTICS.ITEMS.STOCK_RUN_LIST",
        icon: "run-list",
        routerLink: `${StockStatisticsRoutePaths.ROOT}${StockStatisticsRoutePaths.RUN_LIST}`,
        permissions: COMMON_GUARD_OPTIONS.STOCK_STATISTICS.VIEW.permissions,
      },
    ]);
  },
});
